import React from "react";

const Footer2 = () => {
  return (
    <footer
     dir="ltr"
    className="w-full text-center font-[BdReg] py-10 relative bg-transparent">
      
      {/* TOP LINE */}
      <span className="block w-full h-px bg-black/60 mb-5" />

      {/* TEXT */}
      <p className="text-sm text-black tracking-wide">
        © 2026 © VOYAH All Rights Reserved.
      </p>

    </footer>
  );
};

export default Footer2;
